module.exports = __webpack_public_path__ + "static/media/400175_02.73c3e950.png";